define('jquery', [], function() {
    return jQuery;
});

// Set the require.js configuration for the application
// This paths get appended to by `grunt bower`. The map
// is there so that calls to underscore resolve to lodash.
require.config({
  waitSeconds: 50,
  baseUrl: '/wp-content/themes/sage-8.4.2/assets/scripts',
  stubModules: [
    'text'
  ],
  map: {
    '*': {
      underscore: 'lodash'
    }
  },
  paths: {
    // jquery: 'empty:',
    domReady: 'vendor/domReady/domReady',
    // jquery: 'bower_components/jquery/dist/jquery',
    'jquery-ui': 'vendor/jquery-ui/jquery-ui',
    'jquery-easing': 'bower_components/jquery.easing/js/jquery.easing',
    'jquery-color': 'lib/jquery-color/jquery.color',
    'jquery-slimscroll': 'vendor/jquery.slimscroll/jquery.slimscroll.min',
    'jquery-fullPage': 'vendor/jquery.fullPage/jquery.fullPage.min',
    smoothScroll: 'bower_components/jquery-smooth-scrolling/jquery.smoothscroll',
    underscore: 'bower_components/underscore/underscore',
    lodash: 'bower_components/lodash/dist/lodash.compat',
    fastclick: 'bower_components/fastclick/lib/fastclick',
    'requirejs-text': 'bower_components/requirejs-text/text',
    modernizr: 'bower_components/modernizr/modernizr',
    velocity: 'bower_components/velocity/velocity',
    validation: 'bower_components/jquery-validation/dist/jquery.validate',
    inview: 'lib/jquery-inview/jquery.inview',
    owl: 'lib/owl.carousel/dist/owl.carousel',
    animateNumber: 'lib/jquery-animateNumber/jquery.animateNumber',
    localscroll:'vendor/jquery.localscroll/jquery.localscroll-1.2.7-min',
    TweenMax:  "vendor/greensock/TweenMax",
    TweenLite: "vendor/greensock/TweenLite",
    CSSPlugin: "vendor/greensock/plugins/CSSPlugin",
    TimelineLite: "vendor/greensock/TimelineLite",
    TimelineMax: "vendor/greensock/TimelineMax",
    EasePack: "vendor/greensock/easing/EasePack",
    ScrollToPlugin:'vendor/greensock/plugins/ScrollToPlugin',
    ScrollMagic: 'vendor/scrollmagic/ScrollMagic',
    'ScrollMagic-gsap': 'vendor/scrollmagic/plugins/animation.gsap',
    'ScrollMagic-debug': 'vendor/scrollmagic/plugins/debug.addIndicators',
  },
  packages: [

  ],
  shim: {
    bootstrap : { "deps" : ["jquery"] },
    animateNumber : { "deps": ["jquery"] },
    owl : { "deps": ["jquery"] },
    validation : { "deps": ["jquery"] },
    inview : { "deps": ["jquery"] },
    'jquery-easing' : { "deps": ["jquery"] },
    'jquery-color' : { "deps": ["jquery"] },
    'jquery-slimscroll' : { "deps": ["jquery"] },
    'jquery-fullPage' : { "deps": ["jquery"] }
  }
});

// Start the application
require(['modernizr', 'velocity','start']);
